import { configFetch as fetch } from '@laigu/utils';

export const addClientTagApi = ({ trackId, tagId, convId }) => {
  return fetch({
    url: `/agent/client/${trackId}/tags`,
    method: 'post',
    data: {
      tag_id: tagId,
      conv_id: convId
    }
  });
};

export const removeClientTagApi = ({ trackId, tagId, convId }) => {
  return fetch({
    url: `/agent/client/${trackId}/tags/${tagId}?conv_id=${convId}`,
    method: 'delete',
    data: {
      conv_id: convId
    }
  });
};
